import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import parse from 'html-react-parser';

interface H5CommonPopupNewProps {
    app?: AppStore;
    desktopMode?: boolean;
    site?: SiteStore;
    user?: UserAction;
    // 是否显示标题
    isShowTitle?: boolean;
    // 是否显示取消按钮
    isShowCancel?: boolean;
    // 是否显示确定按钮
    isShowConfirm?: boolean;
    // 是否显示
    visible: boolean;
     // 显示隐藏
    onHidePopup?: Function
    // 标题
    title?: string;
    // 使用richtext解析
    useRichtext?: boolean
    // richtext内容
    richtextContent?: any
    // 取消事件
    onCancelChange?: Function
    // 确定事件
    onConfirmButtonChange?: Function
    // 取消按钮文字
    cancelText?: string
    // 确定按钮文字
    confirmText?: string
    // 确定按钮不可点击状态
    confirmDisabled?: boolean
    // 是否给弹窗内容添加背景样式 class
    popupContentBg?: boolean;
    // 弹窗内容自定义样式 class
    popupContentClassName?: string;
    // childrenSlot 容器的行内样式
    childrenSlotStyle?: React.CSSProperties;
    // 插槽相关属性
    children?: React.ReactNode; // 内容插槽
}

@inject('app', 'site', 'user')
@observer
class H5CommonPopupNew extends React.Component<H5CommonPopupNewProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }
    // 隐藏
    onHidePopup = () => {
        this.props.onCancelChange && this.props.onCancelChange()
    }

    render() {
        let { desktopMode = false, isShowTitle = true, isShowCancel = true, isShowConfirm = true, visible, title,  richtextContent = '',  cancelText = '取消', confirmText = '确认', confirmDisabled = false, popupContentBg = false, popupContentClassName, childrenSlotStyle, children } = this.props
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };
        return <>
            <div className={classNames(styles.popupBox, visible ? styles.openPopup : '', desktopMode && styles.desktopMode)}>
                <div className={classNames(styles.popupMask)} onClick={this.onHidePopup}></div>
                <div className={classNames(styles.popupContent, popupContentBg && styles.popupContentBg, popupContentClassName)}>
                    {isShowTitle && <div className={styles.popupTitleBox}>
                        {/* <div className={classNames(styles.popupTitle)}>{title || '提示'}</div> */}
                        {/* 内容 */}
                        <div className={styles.richtext}>
                            {parse(title || '提示', parserOptions)}
                        </div>
                    </div>}
                    {children && <div className={styles.childrenSlot} style={childrenSlotStyle}>
                        {children}
                    </div>}

                    {/* {(useRichtext && !!richtextContent) && <RichText nodes={richtextContent} style={' word-break: break-all;'} ></RichText>} */}

                    {
                        (!!isShowCancel && !!!isShowConfirm) && <div className={classNames(styles.popupBtnBox, styles.onlyOneBtn)}>
                            <div className={styles.cancelButton} style={{flex:1, margin: 0}} onClick={() => {
                                this.props.onCancelChange && this.props.onCancelChange()
                            }}>{cancelText}</div>
                        </div>
                    }
                    {
                        (!!!isShowCancel && !!isShowConfirm) && <div className={classNames(styles.popupBtnBox, styles.onlyOneBtn)}>
                            <div className={classNames(styles.confirmButton, confirmDisabled ? styles.disabledConfirmBtn : '')} style={{flex:1, margin: 0}} onClick={(e) => {
                                if(!confirmDisabled) {
                                    this.props.onConfirmButtonChange && this.props.onConfirmButtonChange()
                                }
                            }}>{confirmText}</div>
                        </div>
                    }
                    {
                        (!!isShowCancel && !!isShowConfirm) && <div className={classNames(styles.popupBtnBox)}>
                            <div className={classNames(styles.confirmButton, confirmDisabled ? styles.disabledConfirmBtn : '')} onClick={(e) => {
                                if(!confirmDisabled) {
                                    this.props.onConfirmButtonChange && this.props.onConfirmButtonChange()
                                }
                            }}>{confirmText}</div>
                            <div className={styles.cancelButton} onClick={() => {
                                this.props.onCancelChange && this.props.onCancelChange()
                            }}>{cancelText}</div>
                        </div>
                    }
                    
                </div>
            </div>
        </>;
        
    }
}

export default H5CommonPopupNew;
